/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Nohraclinic API
 * API do Nohraclinic. Sessão web por cookie httpOnly; mobile por bearer. As rotas sob /v1/auth/* que não estão aqui são servidas pelo handler do better-auth, restrito a uma allowlist (ver src/modules/auth/auth.mount.ts): sign-in/email, sign-out, get-session, verify-email, send-verification-email, request-password-reset e reset-password. O cadastro entra só por POST /v1/auth/registro.
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  ErroResponse,
  ListaDeCandidatosAMesclagemResponse,
  MesclagemDePacientesControllerListarParams,
  MesclagemDePacientesControllerPreviaParams,
  MesclagemResponse,
  MesclarPacientesDto,
  PaginaDeMesclagensResponse,
  PreviaDeMesclagemResponse
} from '../model';

import { httpClient } from '../../http-client.ts';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getMesclagemDePacientesControllerListarUrl = (params?: MesclagemDePacientesControllerListarParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/pacientes-mesclagens?${stringifiedParams}` : `/v1/pacientes-mesclagens`
}

/**
 * @summary Histórico de mesclagens do ambiente, mais recentes primeiro.
 */
export const mesclagemDePacientesControllerListar = async (params?: MesclagemDePacientesControllerListarParams, options?: Parameters<typeof httpClient>[1]): Promise<PaginaDeMesclagensResponse> => {

  return httpClient<PaginaDeMesclagensResponse>(getMesclagemDePacientesControllerListarUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getMesclagemDePacientesControllerListarQueryKey = (params?: MesclagemDePacientesControllerListarParams,) => {
    return [
    `/v1/pacientes-mesclagens`, ...(params ? [params] : [])
    ] as const;
    }


export const getMesclagemDePacientesControllerListarQueryOptions = <TData = Awaited<ReturnType<typeof mesclagemDePacientesControllerListar>>, TError = unknown>(params?: MesclagemDePacientesControllerListarParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mesclagemDePacientesControllerListar>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMesclagemDePacientesControllerListarQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof mesclagemDePacientesControllerListar>>> = ({ signal }) => mesclagemDePacientesControllerListar(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof mesclagemDePacientesControllerListar>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type MesclagemDePacientesControllerListarQueryResult = NonNullable<Awaited<ReturnType<typeof mesclagemDePacientesControllerListar>>>
export type MesclagemDePacientesControllerListarQueryError = unknown


export function useMesclagemDePacientesControllerListar<TData = Awaited<ReturnType<typeof mesclagemDePacientesControllerListar>>, TError = unknown>(
 params: undefined |  MesclagemDePacientesControllerListarParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof mesclagemDePacientesControllerListar>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof mesclagemDePacientesControllerListar>>,
          TError,
          Awaited<ReturnType<typeof mesclagemDePacientesControllerListar>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMesclagemDePacientesControllerListar<TData = Awaited<ReturnType<typeof mesclagemDePacientesControllerListar>>, TError = unknown>(
 params?: MesclagemDePacientesControllerListarParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mesclagemDePacientesControllerListar>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof mesclagemDePacientesControllerListar>>,
          TError,
          Awaited<ReturnType<typeof mesclagemDePacientesControllerListar>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMesclagemDePacientesControllerListar<TData = Awaited<ReturnType<typeof mesclagemDePacientesControllerListar>>, TError = unknown>(
 params?: MesclagemDePacientesControllerListarParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mesclagemDePacientesControllerListar>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Histórico de mesclagens do ambiente, mais recentes primeiro.
 */

export function useMesclagemDePacientesControllerListar<TData = Awaited<ReturnType<typeof mesclagemDePacientesControllerListar>>, TError = unknown>(
 params?: MesclagemDePacientesControllerListarParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mesclagemDePacientesControllerListar>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMesclagemDePacientesControllerListarQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getMesclagemDePacientesControllerMesclarUrl = () => {




  return `/v1/pacientes-mesclagens`
}

/**
 * @summary Junta o absorvido no mantido: move exames, prontuários etc., aplica os campos escolhidos e arquiva o absorvido. Campo em conflito sem escolha é 400 ESCOLHA_PENDENTE.
 */
export const mesclagemDePacientesControllerMesclar = async (mesclarPacientesDto: MesclarPacientesDto, options?: Parameters<typeof httpClient>[1]): Promise<MesclagemResponse> => {

  return httpClient<MesclagemResponse>(getMesclagemDePacientesControllerMesclarUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(mesclarPacientesDto)
  }
);}





export const getMesclagemDePacientesControllerMesclarMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof mesclagemDePacientesControllerMesclar>>, TError,{data: MesclarPacientesDto}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof mesclagemDePacientesControllerMesclar>>, TError,{data: MesclarPacientesDto}, TContext> => {

const mutationKey = ['mesclagemDePacientesControllerMesclar'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof mesclagemDePacientesControllerMesclar>>, {data: MesclarPacientesDto}> = (props) => {
          const {data} = props ?? {};

          return  mesclagemDePacientesControllerMesclar(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MesclagemDePacientesControllerMesclarMutationResult = NonNullable<Awaited<ReturnType<typeof mesclagemDePacientesControllerMesclar>>>
    export type MesclagemDePacientesControllerMesclarMutationBody = MesclarPacientesDto
    export type MesclagemDePacientesControllerMesclarMutationError = ErroResponse

    /**
 * @summary Junta o absorvido no mantido: move exames, prontuários etc., aplica os campos escolhidos e arquiva o absorvido. Campo em conflito sem escolha é 400 ESCOLHA_PENDENTE.
 */
export const useMesclagemDePacientesControllerMesclar = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof mesclagemDePacientesControllerMesclar>>, TError,{data: MesclarPacientesDto}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof mesclagemDePacientesControllerMesclar>>,
        TError,
        {data: MesclarPacientesDto},
        TContext
      > => {
      return useMutation(getMesclagemDePacientesControllerMesclarMutationOptions(options), queryClient);
    }
    export const getMesclagemDePacientesControllerCandidatosUrl = (pacienteId: string,) => {




  return `/v1/pacientes-mesclagens/candidatos/${pacienteId}`
}

/**
 * @summary Pacientes que podem ser juntados a este: mesma espécie e nome parecido ou mesmo tutor.
 */
export const mesclagemDePacientesControllerCandidatos = async (pacienteId: string, options?: Parameters<typeof httpClient>[1]): Promise<ListaDeCandidatosAMesclagemResponse> => {

  return httpClient<ListaDeCandidatosAMesclagemResponse>(getMesclagemDePacientesControllerCandidatosUrl(pacienteId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getMesclagemDePacientesControllerCandidatosQueryKey = (pacienteId: string,) => {
    return [
    `/v1/pacientes-mesclagens/candidatos/${pacienteId}`
    ] as const;
    }


export const getMesclagemDePacientesControllerCandidatosQueryOptions = <TData = Awaited<ReturnType<typeof mesclagemDePacientesControllerCandidatos>>, TError = ErroResponse>(pacienteId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mesclagemDePacientesControllerCandidatos>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMesclagemDePacientesControllerCandidatosQueryKey(pacienteId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof mesclagemDePacientesControllerCandidatos>>> = ({ signal }) => mesclagemDePacientesControllerCandidatos(pacienteId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: pacienteId !== null && pacienteId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof mesclagemDePacientesControllerCandidatos>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type MesclagemDePacientesControllerCandidatosQueryResult = NonNullable<Awaited<ReturnType<typeof mesclagemDePacientesControllerCandidatos>>>
export type MesclagemDePacientesControllerCandidatosQueryError = ErroResponse


export function useMesclagemDePacientesControllerCandidatos<TData = Awaited<ReturnType<typeof mesclagemDePacientesControllerCandidatos>>, TError = ErroResponse>(
 pacienteId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof mesclagemDePacientesControllerCandidatos>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof mesclagemDePacientesControllerCandidatos>>,
          TError,
          Awaited<ReturnType<typeof mesclagemDePacientesControllerCandidatos>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMesclagemDePacientesControllerCandidatos<TData = Awaited<ReturnType<typeof mesclagemDePacientesControllerCandidatos>>, TError = ErroResponse>(
 pacienteId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mesclagemDePacientesControllerCandidatos>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof mesclagemDePacientesControllerCandidatos>>,
          TError,
          Awaited<ReturnType<typeof mesclagemDePacientesControllerCandidatos>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMesclagemDePacientesControllerCandidatos<TData = Awaited<ReturnType<typeof mesclagemDePacientesControllerCandidatos>>, TError = ErroResponse>(
 pacienteId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mesclagemDePacientesControllerCandidatos>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Pacientes que podem ser juntados a este: mesma espécie e nome parecido ou mesmo tutor.
 */

export function useMesclagemDePacientesControllerCandidatos<TData = Awaited<ReturnType<typeof mesclagemDePacientesControllerCandidatos>>, TError = ErroResponse>(
 pacienteId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mesclagemDePacientesControllerCandidatos>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMesclagemDePacientesControllerCandidatosQueryOptions(pacienteId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getMesclagemDePacientesControllerPreviaUrl = (params: MesclagemDePacientesControllerPreviaParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/pacientes-mesclagens/previa?${stringifiedParams}` : `/v1/pacientes-mesclagens/previa`
}

/**
 * @summary Compara os dois pacientes campo a campo e conta o que será movido. Não grava nada.
 */
export const mesclagemDePacientesControllerPrevia = async (params: MesclagemDePacientesControllerPreviaParams, options?: Parameters<typeof httpClient>[1]): Promise<PreviaDeMesclagemResponse> => {

  return httpClient<PreviaDeMesclagemResponse>(getMesclagemDePacientesControllerPreviaUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getMesclagemDePacientesControllerPreviaQueryKey = (params?: MesclagemDePacientesControllerPreviaParams,) => {
    return [
    `/v1/pacientes-mesclagens/previa`, ...(params ? [params] : [])
    ] as const;
    }


export const getMesclagemDePacientesControllerPreviaQueryOptions = <TData = Awaited<ReturnType<typeof mesclagemDePacientesControllerPrevia>>, TError = ErroResponse>(params: MesclagemDePacientesControllerPreviaParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mesclagemDePacientesControllerPrevia>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMesclagemDePacientesControllerPreviaQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof mesclagemDePacientesControllerPrevia>>> = ({ signal }) => mesclagemDePacientesControllerPrevia(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof mesclagemDePacientesControllerPrevia>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type MesclagemDePacientesControllerPreviaQueryResult = NonNullable<Awaited<ReturnType<typeof mesclagemDePacientesControllerPrevia>>>
export type MesclagemDePacientesControllerPreviaQueryError = ErroResponse


export function useMesclagemDePacientesControllerPrevia<TData = Awaited<ReturnType<typeof mesclagemDePacientesControllerPrevia>>, TError = ErroResponse>(
 params: MesclagemDePacientesControllerPreviaParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof mesclagemDePacientesControllerPrevia>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof mesclagemDePacientesControllerPrevia>>,
          TError,
          Awaited<ReturnType<typeof mesclagemDePacientesControllerPrevia>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMesclagemDePacientesControllerPrevia<TData = Awaited<ReturnType<typeof mesclagemDePacientesControllerPrevia>>, TError = ErroResponse>(
 params: MesclagemDePacientesControllerPreviaParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mesclagemDePacientesControllerPrevia>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof mesclagemDePacientesControllerPrevia>>,
          TError,
          Awaited<ReturnType<typeof mesclagemDePacientesControllerPrevia>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMesclagemDePacientesControllerPrevia<TData = Awaited<ReturnType<typeof mesclagemDePacientesControllerPrevia>>, TError = ErroResponse>(
 params: MesclagemDePacientesControllerPreviaParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mesclagemDePacientesControllerPrevia>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Compara os dois pacientes campo a campo e conta o que será movido. Não grava nada.
 */

export function useMesclagemDePacientesControllerPrevia<TData = Awaited<ReturnType<typeof mesclagemDePacientesControllerPrevia>>, TError = ErroResponse>(
 params: MesclagemDePacientesControllerPreviaParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mesclagemDePacientesControllerPrevia>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMesclagemDePacientesControllerPreviaQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getMesclagemDePacientesControllerDesfazerUrl = (id: string,) => {




  return `/v1/pacientes-mesclagens/${id}/desfazer`
}

/**
 * @summary Desfaz a mesclagem: devolve os registros ao absorvido, reativa-o e restaura o cadastro do mantido (só os campos que não foram editados depois).
 */
export const mesclagemDePacientesControllerDesfazer = async (id: string, options?: Parameters<typeof httpClient>[1]): Promise<MesclagemResponse> => {

  return httpClient<MesclagemResponse>(getMesclagemDePacientesControllerDesfazerUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getMesclagemDePacientesControllerDesfazerMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof mesclagemDePacientesControllerDesfazer>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof mesclagemDePacientesControllerDesfazer>>, TError,{id: string}, TContext> => {

const mutationKey = ['mesclagemDePacientesControllerDesfazer'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof mesclagemDePacientesControllerDesfazer>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  mesclagemDePacientesControllerDesfazer(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MesclagemDePacientesControllerDesfazerMutationResult = NonNullable<Awaited<ReturnType<typeof mesclagemDePacientesControllerDesfazer>>>

    export type MesclagemDePacientesControllerDesfazerMutationError = ErroResponse

    /**
 * @summary Desfaz a mesclagem: devolve os registros ao absorvido, reativa-o e restaura o cadastro do mantido (só os campos que não foram editados depois).
 */
export const useMesclagemDePacientesControllerDesfazer = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof mesclagemDePacientesControllerDesfazer>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof mesclagemDePacientesControllerDesfazer>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getMesclagemDePacientesControllerDesfazerMutationOptions(options), queryClient);
    }
